import gql from 'graphql-tag';

export default gql`
  mutation initUploadFileMutation($fileName: String, $language: String, $destination: String, $fileFormat: String) {
    initUploadFileMutation(
      fileName: $fileName
      language: $language
      destination: $destination
      fileFormat: $fileFormat
    ) {
      uploadId
      key
    }
  }
`;
